import * as React from 'react';

import { AppRoutes } from 'constants/routes';

import { BlankRouterLink } from 'basics/links';

import {
    Background,
    BackgroundLeft,
    BackgroundRight,
    MainTitle,
    MainDescription,
    MainLinksContainer,
    ButtonStyled,
    ArrowAlt16Styled,
    BlankExternalLinkStyled,
    ButtonReadMoreStyled,
} from 'pages/delegate/pages/DelegateMain.styled';

const DelegatePageHero = () => (
    <Background>
        <MainTitle>ICE Delegation</MainTitle>
        <MainDescription>
            Delegate your ICE to trusted community members and let them vote on your behalf.
            <br />
            Earn rewards without managing votes yourself or become a delegate and help shape
            protocol incentives
            <MainLinksContainer>
                <BlankRouterLink to={AppRoutes.section.delegate.link.become}>
                    <ButtonStyled withGradient isRounded>
                        Become a Delegate <ArrowAlt16Styled />
                    </ButtonStyled>
                </BlankRouterLink>

                <BlankExternalLinkStyled href="https://docs.aqua.network/ice-delegation/overview">
                    <ButtonReadMoreStyled isRounded>
                        Read more <ArrowAlt16Styled />
                    </ButtonReadMoreStyled>
                </BlankExternalLinkStyled>
            </MainLinksContainer>
        </MainDescription>
        <BackgroundLeft />
        <BackgroundRight />
    </Background>
);

export default DelegatePageHero;
